import { doctorCaptchaActions } from '../../../actions/user/doctor/captcha';

const initialState = {
  loading: false,
  error: null,
  verification_id: null,
  requires_movement: false,
  isValid: false,
  successMessage: null
};

const doctorCaptchaReducer = (state = initialState, action) => {
  switch (action.type) {
    case doctorCaptchaActions.GENERATE_CAPTCHA.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case doctorCaptchaActions.GENERATE_CAPTCHA.SUCCESS:
      return {
        ...state,
        loading: false,
        verification_id: action.payload.verification_id,
        requires_movement: action.payload.requires_movement,
        error: null
      };
    case doctorCaptchaActions.GENERATE_CAPTCHA.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case doctorCaptchaActions.VERIFY_CAPTCHA.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case doctorCaptchaActions.VERIFY_CAPTCHA.SUCCESS:
      return {
        ...state,
        loading: false,
        isValid: action.payload.valid,
        error: null
      };
    case doctorCaptchaActions.VERIFY_CAPTCHA.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        isValid: false
      };
    default:
      return state;
  }
};

export default doctorCaptchaReducer;
